import { inject, Injectable } from '@angular/core'
import { ToastService } from '@mua/toast'

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    private toast = inject(ToastService)

    showSuccess(message: string) {
        this.toast.success(message)
    }

    showError(message: string = 'Error') {
        this.toast.error(message)
    }

    dismiss() {
        this.toast.clear()
    }
}
